(function() {
  function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
      get: v,
      set: s,
      enumerable: true,
      configurable: true
    });
  }
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("5SWup", function(module, exports) {
    $parcel$export(module.exports, "isSwymBisAvailable", function() {
      return $448f5dad87ede000$export$cac796225ff578aa;
    });
    $parcel$export(module.exports, "onSwymBisAvailable", function() {
      return $448f5dad87ede000$export$858bae1b764ca9ee;
    });
    $parcel$export(module.exports, "subscribeForBackInStock", function() {
      return $448f5dad87ede000$export$65a9154226ebdd85;
    });
    var $YjNU1 = parcelRequire("YjNU1");
    function $448f5dad87ede000$var$isBisEnabledBySetting() {
      if (typeof window === "undefined") return false;
      return window.MBF?.settings?.enableBackInStock === true;
    }
    function $448f5dad87ede000$var$getRuntime() {
      if (!$448f5dad87ede000$var$isBisEnabledBySetting()) return null;
      return (0, $YjNU1.initSwymBis)();
    }
    const $448f5dad87ede000$export$597311bb5a89b43c = () => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      return runtime ? runtime.ready() : Promise.resolve();
    };
    const $448f5dad87ede000$export$cac796225ff578aa = () => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      return runtime ? runtime.isAvailable() : false;
    };
    const $448f5dad87ede000$export$858bae1b764ca9ee = callback => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      return runtime ? runtime.onAvailable(callback) : () => {};
    };
    const $448f5dad87ede000$export$65a9154226ebdd85 = args => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      if (!runtime) return Promise.reject(new Error("[swym-bis] disabled by theme setting enable_back_in_stock"));
      return runtime.subscribeForBackInStock(args);
    };
  });
  parcelRegister("YjNU1", function(module, exports) {
    $parcel$export(module.exports, "initSwymBis", function() {
      return $0b54f75990233cb1$export$23cdde14ed5ac142;
    });
    const $0b54f75990233cb1$var$ALLOWED_MEDIA = new Set([ "email", "sms" ]);
    const $0b54f75990233cb1$var$REQUIRED_PRODUCT_FIELDS = [ "epi", "empi", "du", "pr", "iu" ];
    const $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC = "backinstock";
    const $0b54f75990233cb1$var$MAILING_LIST_DISABLED_MESSAGE = "Swym mailing list opt-in is not enabled. Enable the mailing list feature in the Swym dashboard and the theme setting before sending addToMailingList: 1.";
    const $0b54f75990233cb1$var$MAILING_LIST_DISABLED_USER_MESSAGE = "Newsletter opt-in is not available right now. Untick the newsletter box and try again.";
    function $0b54f75990233cb1$var$deferCallback(callback) {
      if (typeof queueMicrotask === "function") {
        queueMicrotask(callback);
        return;
      }
      Promise.resolve().then(callback);
    }
    function $0b54f75990233cb1$var$normalizeSwymSuccessArgs(args) {
      if (!Array.isArray(args) || args.length === 0) return null;
      if (args.length === 1) return args[0];
      return args;
    }
    function $0b54f75990233cb1$var$stringifySwymCallbackValue(value) {
      if (value instanceof Error) return value.message || value.name || "Error";
      if (typeof value === "string") return value.trim() || "empty string";
      if (value === undefined) return "undefined";
      if (value === null) return "null";
      try {
        return JSON.stringify(value);
      } catch (_error) {
        return Object.prototype.toString.call(value);
      }
    }
    function $0b54f75990233cb1$var$getSwymObjectMessage(value) {
      const message = value.message || value.error || value.msg || value.description;
      if (typeof message === "string" && message.trim()) return message.trim();
      if (message && typeof message === "object") return $0b54f75990233cb1$var$stringifySwymCallbackValue(message);
      const responseText = value.responseText || value.response?.text;
      if (typeof responseText === "string" && responseText.trim()) try {
        const parsed = JSON.parse(responseText);
        return $0b54f75990233cb1$var$getSwymObjectMessage(parsed) || $0b54f75990233cb1$var$stringifySwymCallbackValue(parsed);
      } catch (_error) {
        return responseText.trim();
      }
      return "";
    }
    function $0b54f75990233cb1$var$normalizeSwymErrorArgs(args, context = {}) {
      const values = Array.isArray(args) ? args : [ args ];
      const firstDefined = values.find(value => value !== undefined && value !== null);
      const callbackArgs = values.map($0b54f75990233cb1$var$stringifySwymCallbackValue).join(", ");
      const contextDetails = Object.entries(context).filter(([, value]) => value !== undefined && value !== null && value !== "").map(([key, value]) => `${key}: ${$0b54f75990233cb1$var$stringifySwymCallbackValue(value)}`).join(", ");
      const suffixParts = [];
      if (callbackArgs) suffixParts.push(`callback args: ${callbackArgs}`);
      if (contextDetails) suffixParts.push(`request: ${contextDetails}`);
      const withDetails = message => {
        const normalizedMessage = typeof message === "string" && message.trim() ? message.trim() : "subscribeForProductAlert failed";
        const details = suffixParts.length ? ` (${suffixParts.join("; ")})` : "";
        const error = new Error(`[swym-bis] ${normalizedMessage}${details}`);
        error.swymCallbackArgs = values;
        error.swymRequestContext = context;
        return error;
      };
      if (firstDefined instanceof Error) {
        const error = withDetails(firstDefined.message || firstDefined.name);
        error.cause = firstDefined;
        return error;
      }
      if (typeof firstDefined === "string" && firstDefined.trim()) return withDetails(firstDefined);
      if (firstDefined && typeof firstDefined === "object") return withDetails($0b54f75990233cb1$var$getSwymObjectMessage(firstDefined));
      return withDetails();
    }
    function $0b54f75990233cb1$var$assertRuntime() {
      if (typeof window === "undefined") throw new Error("[swym-bis] window is unavailable");
    }
    function $0b54f75990233cb1$var$normalizeAndValidateProduct(product) {
      if (!product || typeof product !== "object") throw new Error("[swym-bis] product must be an object");
      for (const field of $0b54f75990233cb1$var$REQUIRED_PRODUCT_FIELDS) {
        if (!(field in product) || product[field] === null || product[field] === "") throw new Error(`[swym-bis] missing required product field "${field}"`);
      }
      const du = String(product.du).trim().split("#")[0].split("?")[0];
      if (!du) throw new Error("[swym-bis] product.du must be a valid canonical URL");
      return {
        epi: product.epi,
        empi: product.empi,
        du: du,
        pr: product.pr,
        iu: String(product.iu).trim()
      };
    }
    function $0b54f75990233cb1$var$validateMedium(mediumValue, medium) {
      if (!mediumValue || typeof mediumValue !== "string" || mediumValue.trim().length === 0) throw new Error("[swym-bis] mediumValue is required");
      if (!$0b54f75990233cb1$var$ALLOWED_MEDIA.has(medium)) throw new Error('[swym-bis] medium must be either "email" or "sms"');
    }
    function $0b54f75990233cb1$var$isMailingListOptInEnabled() {
      return window.MBF?.settings?.enableBackInStockMailingList === true;
    }
    function $0b54f75990233cb1$var$createSwymBisRuntime() {
      let swatRef = null;
      const availableCallbacks = new Set;
      let readyResolve;
      const readyPromise = new Promise(resolve => {
        readyResolve = resolve;
      });
      const hasBisSubscribeCapability = () => Boolean(swatRef && typeof swatRef.subscribeForProductAlert === "function");
      const setReady = swat => {
        if (!swat || swatRef) return;
        swatRef = swat;
        readyResolve();
        if (!hasBisSubscribeCapability()) return;
        availableCallbacks.forEach(callback => callback());
        availableCallbacks.clear();
      };
      if (window._swat) setReady(window._swat);
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(setReady);
      return {
        ready() {
          return readyPromise;
        },
        isAvailable() {
          return hasBisSubscribeCapability();
        },
        onAvailable(callback) {
          if (typeof callback !== "function") return () => {};
          if (hasBisSubscribeCapability()) {
            callback();
            return () => {};
          }
          availableCallbacks.add(callback);
          return () => availableCallbacks.delete(callback);
        },
        async subscribeForBackInStock({mediumValue: mediumValue, medium: medium = "email", product: product, addToMailingList: addToMailingList = 0} = {}) {
          $0b54f75990233cb1$var$validateMedium(mediumValue, medium);
          const normalizedProduct = $0b54f75990233cb1$var$normalizeAndValidateProduct(product);
          const normalizedAddToMailingList = Number(addToMailingList) === 1 ? 1 : 0;
          if (normalizedAddToMailingList === 1 && !$0b54f75990233cb1$var$isMailingListOptInEnabled()) {
            const error = new Error(`[swym-bis] ${$0b54f75990233cb1$var$MAILING_LIST_DISABLED_MESSAGE}`);
            error.userMessage = $0b54f75990233cb1$var$MAILING_LIST_DISABLED_USER_MESSAGE;
            error.swymRequestContext = {
              medium: medium,
              product: normalizedProduct,
              addToMailingList: normalizedAddToMailingList,
              topic: $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC
            };
            throw error;
          }
          await readyPromise;
          return new Promise((resolve, reject) => {
            let settled = false;
            const resolveOnce = value => {
              if (settled) return;
              settled = true;
              resolve(value);
            };
            const rejectOnceDeferred = (...errorArgs) => {
              const normalizedError = $0b54f75990233cb1$var$normalizeSwymErrorArgs(errorArgs, {
                medium: medium,
                product: normalizedProduct,
                addToMailingList: normalizedAddToMailingList,
                topic: $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC
              });
              $0b54f75990233cb1$var$deferCallback(() => {
                if (settled) return;
                settled = true;
                reject(normalizedError);
              });
            };
            swatRef.subscribeForProductAlert(mediumValue.trim(), medium, normalizedProduct, (...successArgs) => resolveOnce($0b54f75990233cb1$var$normalizeSwymSuccessArgs(successArgs)), (...errorArgs) => rejectOnceDeferred(...errorArgs), normalizedAddToMailingList, $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC);
          });
        }
      };
    }
    function $0b54f75990233cb1$export$23cdde14ed5ac142() {
      $0b54f75990233cb1$var$assertRuntime();
      window.MBF = window.MBF || {};
      if (window.MBF.swymBis) return window.MBF.swymBis;
      const runtime = $0b54f75990233cb1$var$createSwymBisRuntime();
      window.MBF.swymBis = runtime;
      return runtime;
    }
  });
  var $5SWup = parcelRequire("5SWup");
  var $83edca90f6394d82$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("product-form-box")) return;
    customElements.define("product-form-box", class ProductFormBox extends HTMLElement {
      connectedCallback() {
        this.productForm = this.closest("product-form");
        if (!this.productForm) return;
        this.handleStateUpdated = this.handleStateUpdated.bind(this);
        this.handleSwymAvailable = this.handleSwymAvailable.bind(this);
        this.productForm.addEventListener("product-form:state-updated", this.handleStateUpdated);
        this.swymAvailabilityUnsubscribe = (0, $5SWup.onSwymBisAvailable)(this.handleSwymAvailable);
        this.updateFromVariant(this.productForm.currentVariant);
      }
      disconnectedCallback() {
        this.productForm?.removeEventListener("product-form:state-updated", this.handleStateUpdated);
        this.swymAvailabilityUnsubscribe?.();
        this.swymAvailabilityUnsubscribe = null;
      }
      handleStateUpdated(event) {
        this.updateFromVariant(event.detail?.variant || null, event.detail?.variantSummary || null);
      }
      handleSwymAvailable() {
        this.updateFromVariant(this.productForm?.currentVariant || null);
      }
      updateFromVariant(variant, variantSummary = null) {
        if (!variant) return;
        const eventTermsEl = this.querySelector("[data-event-terms]");
        const eventTermsCheckbox = this.querySelector("[data-event-terms-checkbox]");
        const eventTermsCheckboxUI = this.querySelector("[data-event-terms-checkbox-ui]");
        const eventTermsWarning = this.querySelector("[data-event-terms-warning]");
        const isSoldOut = !variant.available;
        if (eventTermsEl) eventTermsEl.classList.toggle("hidden", isSoldOut);
        if (isSoldOut) {
          eventTermsEl?.classList.remove("is-invalid");
          eventTermsCheckbox?.setAttribute("aria-invalid", "false");
          eventTermsWarning?.classList.add("hidden");
          eventTermsCheckboxUI?.classList.remove("border-red");
          eventTermsCheckboxUI?.classList.add("border-scheme-border");
        }
        const variantMap = this.productForm?.getVariantMapData?.() || {};
        const data = variantSummary || variantMap?.[variant.id] || variantMap?.[String(variant.id)];
        if (!data) return;
        const titleEl = this.querySelector("[data-variant-title]");
        const metaEl = this.querySelector("[data-variant-meta]");
        const availabilityStringEl = this.querySelector("[data-availability-string]");
        const availabilityDotEl = this.querySelector("[data-availability-dot]");
        const despatchEl = this.querySelector("[data-despatch-message]");
        const unitLabelEl = this.querySelector("[data-variant-unit-label]");
        const disclaimerEl = this.querySelector("[data-variant-disclaimer]");
        if (titleEl) {
          const titleText = data.title || "";
          titleEl.textContent = titleText;
          titleEl.dataset.variantTitle = titleText;
        }
        if (metaEl) {
          const metaHtml = (data.meta_html || "").trim();
          if (metaHtml) metaEl.innerHTML = `<span class="inline-flex flex-wrap items-center gap-x-1.5 gap-y-0">${metaHtml}</span>`; else metaEl.textContent = data.meta || "";
        }
        if (availabilityStringEl) availabilityStringEl.textContent = data.availability?.string || "";
        if (availabilityDotEl) {
          const baseClass = availabilityDotEl.dataset.baseClass || "w-2 h-2 rounded-full";
          const dotClass = data.availability?.background_class || "";
          availabilityDotEl.className = `${baseClass} ${dotClass}`.trim();
        }
        if (despatchEl) {
          const despatch = data.despatch || "";
          const notifyText = window.MBF?.strings?.outOfStock?.notifyLong || "Translation missing: en.product.out_of_stock.notify_long";
          const isNotifyDespatch = despatch.trim() !== "" && despatch.trim() === notifyText.trim();
          const shouldShowDespatch = despatch.trim() !== "" && (!isNotifyDespatch || (0, $5SWup.isSwymBisAvailable)());
          despatchEl.textContent = shouldShowDespatch ? despatch : "";
          despatchEl.classList.toggle("hidden", !shouldShowDespatch);
        }
        if (unitLabelEl) {
          const unitLabel = (data.unit_label || "").trim();
          unitLabelEl.textContent = unitLabel;
          unitLabelEl.classList.toggle("hidden", !unitLabel);
        }
        if (disclaimerEl) {
          disclaimerEl.innerHTML = data.disclaimer_html || "";
          disclaimerEl.classList.toggle("hidden", !(data.disclaimer_html || "").trim());
        }
        if (eventTermsEl && eventTermsCheckbox?.checked) {
          eventTermsEl.classList.remove("is-invalid");
          eventTermsCheckbox.setAttribute("aria-invalid", "false");
          eventTermsWarning?.classList.add("hidden");
          eventTermsCheckboxUI?.classList.remove("border-red");
          eventTermsCheckboxUI?.classList.add("border-scheme-border");
        }
      }
    });
  })();
})();